import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Atom: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.65145 21.0738C10.2648 20.3948 11.0764 20.0346 12 20.0346V20.0364C14.1659 20.0364 14.9033 21.9851 15.2392 22.0517L15.2383 22.0508L18.8622 19.9923C18.4178 18.656 17.8715 17.6474 18.6987 16.241C19.5003 14.8786 20.6654 14.7777 22.0967 14.5049V14.4986H22.0986V10.3997H22.0967V10.3934C20.7397 10.0881 19.5555 10.107 18.6987 8.65637C17.6181 6.82571 18.9733 5.17779 18.8585 4.8961L18.8576 4.897L15.2299 2.84842C14.2714 3.91728 13.6232 4.86369 11.9999 4.86369C10.3583 4.86369 9.72847 3.90287 8.76998 2.84842L5.14068 4.8961L5.55843 6.14235C6.15797 7.90188 5.06354 9.76131 3.20983 10.1315L1.90057 10.399L1.90699 14.506C3.29981 14.8004 4.46497 14.8265 5.29961 16.2421L5.30052 16.2412C6.12959 17.6486 5.58055 18.658 5.1371 19.9925L8.77016 22.0501L9.65145 21.0738ZM12 6.19704C17.6604 6.19704 20.5131 12.9407 16.5072 16.8695C12.5023 20.7983 5.62544 18.0014 5.62544 12.449C5.62544 8.9965 8.48004 6.19704 12 6.19704ZM15.8691 8.65441C18.0056 10.7507 18.0056 14.1482 15.8691 16.2437C12.4316 19.616 6.52801 17.2153 6.52801 12.449C6.52801 7.6828 12.4306 5.2821 15.8691 8.65441ZM11.5483 8.85252C11.5483 8.26992 12.4508 8.26992 12.4508 8.85252V9.25233C13.9428 9.48915 14.714 10.9209 13.9272 11.155C13.6894 11.2253 13.4387 11.0938 13.3662 10.8615C13.021 9.74761 10.6044 9.92769 10.6044 11.0542C10.6044 12.6381 14.2972 11.2784 14.2972 13.8431C14.2972 14.8138 13.4112 15.4918 12.4508 15.6449C12.4508 15.9331 12.5224 16.4877 11.9991 16.4877C11.4757 16.4877 11.5474 15.9331 11.5474 15.6449C10.0554 15.4081 9.28415 13.9763 10.071 13.7422C10.3088 13.672 10.5594 13.8034 10.632 14.0357C10.9772 15.1496 13.3937 14.9695 13.3937 13.843C13.3937 12.2591 9.70097 13.6188 9.70097 11.0542C9.70097 10.0835 10.587 9.40542 11.5474 9.25233L11.5483 8.85252ZM11.0791 21.1061C9.90208 21.6257 9.43474 23.4529 8.31008 22.8162L4.68995 20.7658C3.33478 19.9986 5.57411 18.4732 4.52101 16.6848L4.52193 16.6839C3.55421 15.1027 1.82363 15.8051 1.20383 15.0613C1.07529 14.9073 1.00092 14.711 1.00092 14.4985V10.3996H1C1 9.12541 2.84363 9.64678 3.89573 8.90387C4.67431 8.35369 5.02321 7.35504 4.70553 6.42207L4.28409 5.18482C4.14546 4.7787 4.31531 4.34468 4.69083 4.13216L4.69175 4.13306L8.31095 2.08268C9.43107 1.44425 9.90851 3.27582 11.08 3.79269C11.9531 4.1781 13.0127 3.97459 13.6765 3.24071L14.5579 2.26369C14.8471 1.94402 15.3145 1.86929 15.6918 2.08269L19.311 4.13217L19.3101 4.13307C20.657 4.89847 18.4213 6.51575 19.4662 8.19326C20.1465 9.28644 20.9517 9.26392 22.2728 9.52777C22.6979 9.61242 23 9.97531 23 10.3994H22.9982V14.4983H23C23 15.7725 21.1555 15.2511 20.1043 15.994C19.3266 16.5433 18.9768 17.5429 19.2954 18.4758L19.7168 19.7131C19.8545 20.1183 19.6865 20.5532 19.311 20.7666L15.6909 22.817L15.6899 22.8161C15.3236 23.0313 14.8453 22.9557 14.557 22.636C13.7453 21.7374 13.2495 20.9197 12.0009 20.9197V20.9215C11.6658 20.9197 11.3573 20.9828 11.0791 21.1061Z'
        fill='url(#paint0_linear_12280_33549)'
        stroke='url(#paint1_linear_12280_33549)'
        strokeWidth='0.8'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_33549'
          x1='5.55569'
          y1='3.38118'
          x2='14.8552'
          y2='22.9076'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_33549'
          x1='5.55569'
          y1='3.38118'
          x2='14.8552'
          y2='22.9076'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Atom;
